<!-- Расходы -->
<template>
  <li
    v-if="canSeePage('expenses')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Expenses')"
    @mouseup="handleMiddleClick($event, 'Expenses')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Expenses')"
    :class="{ active: activeItem === 'expenses' }"
    :title="collapsed ? 'Расходы' : ''"
  >
    <div class="link-icon_box">
      <svg
        fill="#000000"
        height="24px"
        width="24px"
        viewBox="0 0 256 256"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M252,128c0,68.4-55.6,124-124,124S4,196.4,4,128S59.6,4,128,4S252,59.6,252,128z M174.3,155.6c0-26-27.8-33.4-39.8-36.8 c-22.7-6.3-24.6-14.5-24.3-18.7c0.8-10.2,12-12.7,22.4-10.5c8.2,1.8,16.6,6.6,21.3,10.3l14.9-17.4c-7.3-5-16.7-11.5-30.4-14.1V51.5 h-21.7v16.3c-21,1.6-35,14.8-35,32.9c0,17.7,12.8,26,25.6,32.2c10.7,5.1,40.5,10.4,38.8,23.9c-0.9,7.3-8.7,12.7-21.6,11.1 c-11.2-1.4-23.2-10.8-23.2-10.8l-16.4,16.3c9.9,8,20.4,13,31.8,15.3v15.9h21.7v-15.1C159.1,187.2,174.3,173.1,174.3,155.6z"
        />
      </svg>
    </div>
    <AppSidebarItemLabel
      label="Расходы"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "ExpensesItem",
  components: { AppSidebarItemLabel },
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
